import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GcTextComponent } from '@ip-only/front-end-library';
import { RadioButtonInputComponent } from '../components/radio-button-input/radio-button-input.component';
import { ReportSelfInspectionWrapperComponent } from '../components/report-self-inspection-wrapper/report-self-inspection-wrapper.component';
import {
  RadioButtonInputData,
  SelfInspcetionWrapperData,
} from '../report-input-entities';
import { SelfInspectionBaseClassComponent } from '../self-inspection-base-class/self-inspection-base-class.component';

@Component({
  selector: 'app-self-inspection-radio-button',
  imports: [
    ReportSelfInspectionWrapperComponent,
    RadioButtonInputComponent,
    GcTextComponent,
  ],
  templateUrl: './self-inspection-radio-button.component.html',
  styleUrl: './self-inspection-radio-button.component.scss',
})
export class SelfInspectionRadioButtonComponent<
  T,
> extends SelfInspectionBaseClassComponent<T> {
  @Input() wrapperData: SelfInspcetionWrapperData;
  @Input() title: string;
  @Input() data: RadioButtonInputData;

  @Output() checkedValue = new EventEmitter<T>();

  get selfInspectionId(): string {
    return this.data.id;
  }

  handleCheckedValue(value: string) {
    this.setIsLoadingTrue();
    this.checkedValue.emit({ radioButton: value } as T);
  }
}
